"use strict";

exports.__esModule = true;
exports.SlidingTimeline = void 0;
var _react = require("react");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _libTimeline = require("@vimana/lib-timeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var makeTimelineItem = function makeTimelineItem(interval, value) {
  return {
    interval: {
      startMillis: interval.endMillis,
      endMillis: interval.endMillis
    },
    value: value
  };
};
var makeTimelinesFromProps = function makeTimelinesFromProps(_ref) {
  var interval = _ref.interval,
    latestValues = _ref.latestValues;
  return latestValues.map(function (value) {
    return [makeTimelineItem(interval, value)];
  });
};
var SlidingTimeline = exports.SlidingTimeline = /*#__PURE__*/function (_Component) {
  function SlidingTimeline() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      timelines: makeTimelinesFromProps(_this.props),
      prevPropsInterval: _this.props.interval,
      prevPropsLatestValues: _this.props.latestValues
    };
    return _this;
  }
  _inheritsLoose(SlidingTimeline, _Component);
  SlidingTimeline.getDerivedStateFromProps = function getDerivedStateFromProps(_ref2, prevState) {
    var interval = _ref2.interval,
      latestValues = _ref2.latestValues;
    if ((0, _reactFastCompare["default"])(interval, prevState.prevPropsInterval) && (0, _reactFastCompare["default"])(latestValues, prevState.prevPropsLatestValues)) {
      return null;
    }
    if (latestValues.length !== prevState.prevPropsLatestValues.length) {
      return {
        timelines: makeTimelinesFromProps({
          interval: interval,
          latestValues: latestValues
        }),
        prevPropsInterval: interval,
        prevPropsLatestValues: latestValues
      };
    }
    var predicate = (0, _libTimeline.createOverlappingPredicate)(interval);
    var timelines = prevState.timelines.map(function (timeline, i) {
      return timeline.filter(predicate).concat(makeTimelineItem(interval, latestValues[i]));
    });
    return {
      timelines: timelines,
      prevPropsInterval: interval,
      prevPropsLatestValues: latestValues
    };
  };
  var _proto = SlidingTimeline.prototype;
  _proto.render = function render() {
    return this.props.children(this.state.timelines);
  };
  return SlidingTimeline;
}(_react.Component);